import React from 'react';
import $ from "jquery";
import logo from '../assets/images/icons/new-logo.svg';
import menu from '../assets/images/Main/side menu icon.svg';
import Sidebar from "react-sidebar";
import { Link } from "react-router-dom";
import { DropdownButton, Dropdown } from 'react-bootstrap';
export default class Header extends React.Component {
    constructor(props) {
        super(props);
        var user = null;
        var access_token = '';
        if (sessionStorage.getItem('user')) {
            user = JSON.parse(sessionStorage.getItem('user'));
        }
        if (sessionStorage.getItem('access_token')) {
            access_token = sessionStorage.getItem('access_token');
        }
        this.state = {
            sidebarOpen: false,
            user: user,
            access_token: access_token,
            selectedOption: 'Browse'
        };
        this.style = props.style;
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    }
    onSetSidebarOpen(open) {
        this.setState({ sidebarOpen: open });
        console.log(open);
    }
    Second() {
        this.setState({ sidebarOpen: false });
    }
    First() {
        this.setState({ sidebarOpen: false });
    }
    goToSearch(category) {
        console.log(category)
        localStorage.setItem('searchCategory', category)
    }
    render() {
        var block = '';
        if (this.state.user) {
            block = [
                <li key="user"><Link to="/">{this.state.user.name}</Link></li>,
                <li key="logout"><Link to="/signout">Logout</Link></li>
            ]
        }
        else {
            block = [
                <li key="signin"><Link to="/signin">Sign In</Link></li>,
                <li key="signout"><Link to="/signup">Sign Up</Link></li>
            ];
        }
        return (
            <div className="header-section section @@headerClass" style={this.style}>

                <div className=" navbar bg-light navbar-expand-md main-nav primary-menu">
                    <div className="container">
                        <div className="line_btm">
                            <Link className="navbar-brand pt-0" to="/">
                                <div className="header-logo">
                                    <img src={logo} className="img-responsive" alt="Header logo image" />
                                </div>
                            </Link>

                            <div className="navbar-collapse collapse">
                                <ul className="nav navbar-nav mr-auto header-navigation-bar">
                                    <li className="nav-item">
                                        <Link to="/why-charter" className="nav-link">Why Charter?</Link></li>
                                    <div id="newheadrop">
                                        <DropdownButton
                                            title="Browse"
                                            variant="link"
                                            onSelect={(category) => {this.goToSearch(category)}}
                                        >
                                            <Dropdown.Item eventKey="sale" href="/search" key="sale">For Sale</Dropdown.Item>
                                            <Dropdown.Item eventKey="charter" href="/search" key="charter">For Charter</Dropdown.Item>
                                        </DropdownButton>
                                        {/* <DropdownMenu>
                                            <Link to={{ pathname: "/search", category: "sale" }} >For Sale</Link>
                                            <br></br>
                                            <Link to={{ pathname: "/search", category: "charter" }} >For Charter</Link>
                                        </DropdownMenu> */}
                                    </div>
                                </ul>
                                <Sidebar
                                    sidebar={<div className="overlay" onClick={() => this.First()}>
                                        <div className="wrap" onClick={() => this.Second()}>
                                            <ul className="wrap-navmenu">
                                                <h3 className="over_menu">Menu</h3>

                                                <li><Link to="/">Home</Link></li>
                                                <li><Link to="/search">Search</Link></li>
                                                <li><Link to="/why-charter">Why Charter?</Link></li>
                                                <li><Link to="/destinations">Destinations</Link></li>
                                                <li><Link to="/blog">Blog</Link></li>
                                                <ul className="mobile_menuofside">
                                                    <li><Link className="tt-item" to={{ pathname: "/search", category: "sale" }}>For Charter</Link></li>
                                                    <li><Link className="tt-item" to={{ pathname: "/search", category: "charter" }}>For Sale</Link></li>
                                                </ul>
                                                <hr />
                                                {block}
                                                <hr />
                                                <li className="light_over_menu"><a target="_blank" href={process.env.REACT_APP_BASE_URL + "/users/sign_in?access_token=" + this.state.access_token}>My Dashboard</a></li>
                                                {/* <li className="light_over_menu"><a target="_blank" href={process.env.REACT_APP_BASE_URL}>Admin Dashboard</a></li> */}
                                                {/* <li className="light_over_menu"><a target="_blank" href={process.env.REACT_APP_BASE_URL}>Broker Dashboard</a></li> */}
                                            </ul>
                                        </div>
                                    </div>}
                                    open={this.state.sidebarOpen}
                                    onSetOpen={this.onSetSidebarOpen}
                                    pullRight={true}
                                    sidebarClassName={'sidebarclass'}
                                    contentClassName={'contentclas'}
                                    overlayClassName={'overlayclas'}
                                    rootClassName={'rootclsname'}
                                    styles={{ sidebar: { background: "rgba(7, 21, 41, 0.85)" } }} >
                                    <div className="side-megamenu">
                                        <nav>
                                            <div className="button">
                                                <a className="btn-open" onClick={() => this.onSetSidebarOpen(true)}>
                                                    <div className="menu-icon">
                                                        <img src={menu} className="img-responsive" alt="Menu icon" />
                                                    </div>
                                                    <span>Menu</span>
                                                </a>
                                            </div>
                                        </nav>
                                    </div>
                                </Sidebar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//this is $ means jquery now you need to understand how jquery codes works and fit that in react 
